export const REFUND_METHOD_HELP_TEXT_MAP = {
  GIFT_CARD: 'Issues a gift card for store credit. Instant delivery via email.',
  ORIGINAL_PAYMENT_METHOD:
    "Refunds money for the returned items back to the customer's original payment method (credit card, PayPal, etc.)."
};
